// extracted by mini-css-extract-plugin
export default {"main":"LubricantService_main__6pKZd","tabContent":"LubricantService_tabContent__NQ4jA"};